import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  class: "offline_svg__svg-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "m21.5 23-5.472-5.472-3.182-3.182L10.8 12.3l-1.762-1.762-1.653-1.653L5.79 7.29 1 2.5l1.25-1.25 5.375 5.375C12.903 5.083 18.837 6.394 23 10.556l-1.467 1.467A13.47 13.47 0 0 0 9.338 8.338l1.84 1.84a11.382 11.382 0 0 1 8.889 3.312L18.6 14.956a9.293 9.293 0 0 0-5.285-2.64l9.435 9.434L21.5 23Zm-9.115-6.615-1.924-1.924a7.225 7.225 0 0 0-3.594 1.962l1.466 1.467a5.173 5.173 0 0 1 4.052-1.505ZM8.79 12.79l-1.587-1.587a11.385 11.385 0 0 0-3.27 2.287L5.4 14.956a9.3 9.3 0 0 1 3.39-2.166ZM5.656 9.656 4.132 8.132A15.581 15.581 0 0 0 1 10.556l1.467 1.467a13.48 13.48 0 0 1 3.189-2.367Zm8.544 9.7a3.111 3.111 0 0 0-4.4 0l2.2 2.2 2.2-2.2Z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }